import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LorenChartUtilsService {

    static getXAxisSteps(dataLength: number, isHandset: boolean): number {
        let xAxisStep;

        if (dataLength < 26) { // 1 day
            xAxisStep = isHandset ? 6 : 3;
        } else if (dataLength < 170) { // 1 week
            xAxisStep = isHandset ? 30 : 21;
        } else if (dataLength < 730) { // 1 month
            xAxisStep = 90;
        } else if (dataLength < 1500) {
            xAxisStep = 300;
        } else if (dataLength < 4330) { // 6 months
            xAxisStep = 540;
        } else {
            xAxisStep = 1000;
        }

        return xAxisStep;
    }
}
